import React, { useEffect, useRef, useState, useCallback } from "react";
import PrescriptionForm from "./PrescriptionForm";
import MedicationIcon from "@mui/icons-material/Medication";
import PrintIcon from "@mui/icons-material/Print";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../../redux/store";
import {
  setPresPrintaction,
  setPresPrintclinic,
  setPresPrintPatient,
  setPresPrintTreatment,
} from "../../../../../../redux/printstate/printActions";
import baseUrl from "../../../../../../api/baseUrl";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import PrePrint from "../../../../setting/preprint/PrePrint";
import { useParams } from "react-router-dom";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../../redux/loader/loaderActions";
import {
  addAditionalNote,
  addDiagnoseNote,
  addDiagnoses,
  addDiagnosesImage,
  addInvestigations,
  addPatientComplains,
  addPrescriptions,
  addTreatmentImage,
  removePrescription,
} from "../../../../../../redux/diagnosestate/diagnoseAction";
import { toast } from "react-toastify";
function Prescription() {
  const dispatch = useDispatch();
  const { ID } = useParams<{ ID: string }>();
  const prescription = useSelector(
    (state: RootState) => state.diagnose.prescription
  );
  const printRef = useRef<HTMLDivElement>(null);
  const [printData, setPrintData] = useState("");
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const getData = useCallback(() => {
    if (!ID) return;

    dispatch(setloadeActive());
    baseUrl
      .get("treatment/find-treatment", {
        headers: { treatmentid: ID },
      })
      .then((response) => {
        const {
          aditionalNote,
          patientComplain,
          diagnose,
          imageDiagnose,
          imageTreatment,
          complain,
          investigation,
          prescription,
        } = response.data.data;

        function cleanDoseArray(data: any) {
          return data.map((item: any) => ({
            _id: item?._id || "",
            dose: item?.doseId || "",
            drugsId: item?.drugsId?._id || "",
            drugs: item?.drugsId?.drugs || "",
            type: item?.drugsId?.type || "",
            duration: item?.duration || "",
            frequency: item?.frequency || "",
            createdAt: item?.createdAt || "",
          }));
        }

        dispatch(addAditionalNote(aditionalNote ?? ""));
        dispatch(addDiagnoseNote(patientComplain ?? ""));
        dispatch(addDiagnoses(diagnose ?? []));
        dispatch(addDiagnosesImage(imageDiagnose ?? []));
        dispatch(addTreatmentImage(imageTreatment ?? []));
        dispatch(addPatientComplains(complain ?? []));
        dispatch(addInvestigations(investigation ?? []));
        dispatch(addPrescriptions(cleanDoseArray(prescription) ?? []));
      })
      .catch(console.error)
      .finally(() => dispatch(setloadeDeactive()));
  }, [ID, dispatch]);

  useEffect(() => {
    getData();
  }, [getData]);
  useEffect(() => {
    if (printData) {
      handleDownloadPdf();
    }
  }, [printData]);

  const dispatchPrintActions = useCallback(
    (e: any) => {
      e?.other?.clinicId?.prescriptionBill?.forEach((element: any) => {
        const { title, top, left, show, size } = element;
        if (top)
          dispatch(
            setPresPrintaction({ name: title, target: "top", value: top })
          );
        if (left)
          dispatch(
            setPresPrintaction({ name: title, target: "left", value: left })
          );
        if (show !== undefined)
          dispatch(
            setPresPrintaction({ name: title, target: "show", value: show })
          );
        if (size)
          dispatch(
            setPresPrintaction({ name: title, target: "size", value: size })
          );
      });
      dispatch(
        setPresPrintclinic({
          clinicName: e?.other?.clinicId?.title,
          tpNo: e?.other?.clinicId?.tpNo,
          address: e?.other?.clinicId?.address,
          drName: e?.other?.doctorId?.firstName,
          printImages: e?.other?.clinicId?.printImages,
        })
      );
      dispatch(
        setPresPrintPatient({
          invoiceNo: e?.other?.invoiceNo,
          regNo: e?.patientData?.regNo,
          fullName: e?.patientData?.fullName,
          mobileNo: e?.patientData?.mobileNo,
          gender: e?.patientData?.gender,
          dob: e?.patientData?.dob,
        })
      );

      function cleanDoseArray(data: any) {
        return data.map((item: any) => ({
          _id: item?._id || "",
          dose: item?.doseId || "",
          drugsId: item?.drugsId?._id || "",
          drugs: item?.drugsId?.drugs || "",
          type: item?.drugsId?.type || "",
          duration: item?.duration || "",
          frequency: item?.frequency || "",
          createdAt: item?.createdAt || "",
        }));
      }

      dispatch(setPresPrintTreatment(cleanDoseArray(e?.prescription)));
    },
    [dispatch]
  );
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;

    setSelectedIds((prev) => {
      if (checked) {
        return [...prev, name];
      } else {
        return prev.filter((id) => id !== name);
      }
    });
  };
  const handlePrint = useCallback(
    async (e: any) => {
      try {
        if (selectedIds.length === 0) {
          toast.error("select prescription.");
          return;
        }
        const response = await baseUrl.get(
          "/client/treatments/prescription/getPrescriptionById",
          {
            headers: { treatmentid: e, prescrip: selectedIds },
          }
        );

        setPrintData(response.data);
        dispatchPrintActions(response.data);
      } catch (error) {
        console.log(error);
      }
    },
    [selectedIds]
  );

  const remove = useCallback(
    async (e: any) => {
      try {
        const response = await baseUrl.patch(
          "/client/treatments/prescription/removePrescription",
          {},
          {
            headers: { treatmentid: ID, prescriptionid: e },
          }
        );
        console.log({ treatmentid: ID, prescriptionid: e });
        dispatch(removePrescription({ hasId: true, _id: e }));
      } catch (error) {
        console.log(error);
      }
    },
    [selectedIds]
  );

  const handleDownloadPdf = async () => {
    if (printRef.current) {
      printRef.current.style.display = "block";
      const element = printRef.current;
      const options = {
        scale: 2, // Improve quality
        useCORS: true, // Allow cross-origin images
        allowTaint: true,
      };

      const canvas = await html2canvas(element, options);
      const imgData = canvas.toDataURL("image/png");

      const imgWidth = 210; // A4 width in mm
      const imgProps = canvas.width / canvas.height;
      const imgHeight = imgWidth / imgProps; // Auto height based on aspect ratio

      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: [imgWidth, imgHeight], // Dynamic height
      });

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight, "", "FAST");

      const pdfBlob = pdf.output("blob");
      const blobUrl = URL.createObjectURL(pdfBlob);

      // Create an iframe and append to document
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.width = "0";
      iframe.style.top = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      printRef.current.style.transform = "none";
      document.body.appendChild(iframe);
      iframe.src = blobUrl;

      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
          printRef.current!.style.display = "none";
        }, 500);
      };
    } else {
      console.error("Content ref is not defined");
    }
  };
  return (
    <div className="space-y-3 ">
      {/* Header */}
      <div className="flex items-center gap-2.5 p-2 bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
        <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center">
          <MedicationIcon className="text-teal-600" sx={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="text-sm font-bold text-slate-800">Prescription</h3>
          <p className="text-xs text-slate-500">{prescription?.length || 0} drugs prescribed</p>
        </div>
      </div>

      {/* Form */}
      <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 p-4">
        <PrescriptionForm />
      </div>

      {/* Prescription Table */}
      <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
        <div className="px-4 py-2.5 border-b border-slate-200 flex items-center justify-between">
          <h4 className="text-sm font-semibold text-slate-800">Prescription List</h4>
          <button
            onClick={() => handlePrint(ID)}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-gradient-to-r from-teal-500 to-emerald-600 text-white font-medium text-xs hover:shadow-lg hover:shadow-teal-200 transition-all"
          >
            <PrintIcon sx={{ fontSize: 14 }} />
            Print Selected
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-50 border-b border-slate-100">
              <tr>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase w-10">
                  <input
                    type="checkbox"
                    className="w-3.5 h-3.5 rounded border-slate-300 text-teal-600 focus:ring-teal-500"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedIds(prescription.map((p: any) => p._id));
                      } else {
                        setSelectedIds([]);
                      }
                    }}
                    checked={selectedIds.length === prescription?.length && prescription?.length > 0}
                  />
                </th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Drugs</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Dose</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Frequency</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Duration</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Date</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {prescription?.map((item: any, i: number) => (
                <tr key={i} className={`hover:bg-slate-50 transition-colors ${selectedIds.includes(item._id) ? "bg-teal-50" : ""}`}>
                  <td className="px-3 py-2">
                    <input
                      type="checkbox"
                      name={item._id}
                      checked={selectedIds.includes(item._id)}
                      onChange={handleCheckboxChange}
                      className="w-3.5 h-3.5 rounded border-slate-300 text-teal-600 focus:ring-teal-500"
                    />
                  </td>
                  <td className="px-3 py-2 text-xs font-medium text-slate-800">{item.drugs}</td>
                  <td className="px-3 py-2 text-xs text-slate-600">
                    <span className="px-2 py-0.5 bg-teal-100 text-teal-700 rounded-md text-xs font-medium">
                      {item.dose}{item.type}
                    </span>
                  </td>
                  <td className="px-3 py-2 text-xs text-slate-600">{item.frequency}</td>
                  <td className="px-3 py-2 text-xs text-slate-600">{item.duration} days</td>
                  <td className="px-3 py-2 text-xs text-slate-500">{item?.createdAt?.split("T")[0]}</td>
                  <td className="px-3 py-2">
                    <button
                      onClick={() => remove(item?._id)}
                      className="w-7 h-7 rounded-lg bg-red-100 text-red-600 hover:bg-red-200 flex items-center justify-center transition-colors"
                    >
                      <DeleteOutlineIcon sx={{ fontSize: 14 }} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {prescription?.length === 0 && (
            <div className="py-8 text-center text-slate-400">
              <MedicationIcon sx={{ fontSize: 36 }} className="mb-2" />
              <p className="text-xs">No prescriptions added yet</p>
            </div>
          )}
        </div>
      </div>

      {/* Hidden Print Area */}
      <div style={{ position: "absolute", left: "-9999px" }}>
        <div ref={printRef} style={{ display: "none" }}>
          <PrePrint />
        </div>
      </div>
    </div>
  );
}

export default Prescription;
